import { XCircleIcon } from "@heroicons/react/20/solid";
import { useTranslations } from "use-intl";
import { QuoteStatus } from "@/gql/graphql";
import { QuoteRecord } from "@/app/Quotes/GraphQL/quoteRecordQuery";

export function QuoteDeclinedAlert({ quote }: { quote: QuoteRecord }) {
  const t = useTranslations("quote.declinedBanner");
  const tReasons = useTranslations("quote.declineDialog.reasons");

  if (quote.status !== QuoteStatus.Rejected || !quote.declined_reason) {
    return null;
  }

  return (
    <div className="flex gap-3 rounded-lg border border-red-200 bg-red-50 p-4">
      <XCircleIcon className="mt-0.5 size-5 shrink-0 text-red-500" />
      <div className="text-sm">
        <div className="font-semibold text-red-900">{t("title")}</div>
        <div className="mt-0.5 text-red-800">
          {tReasons(quote.declined_reason)}
        </div>
        {quote.declined_reason_description ? (
          <div className="mt-2">
            <div className="text-xs font-medium text-red-900">
              {t("feedbackLabel")}
            </div>
            <p className="mt-0.5 whitespace-pre-wrap text-red-800">
              {quote.declined_reason_description}
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
}
